import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useColors } from '../../../hooks/useColors';
import { useTextReplacement } from '../../../hooks/useTextReplacement';

const FilterContainer = ({ title, hasActiveFilters, children }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { semantic } = useColors();
  const { replace } = useTextReplacement();

  return (
    <div className="mb-4 space-y-4">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className={`w-full flex items-center justify-between rounded-md ${semantic.sectionBg} 
        px-3 py-2 text-sm font-normal ${semantic.contentCardLink} hover:${semantic.contentCardLink} hover:${semantic.sectionBg}
        focus:outline-none focus:ring-2 focus:ring-accent-500`}
        aria-expanded={isExpanded}
        aria-controls="filter-content"
      >
        <span>{replace(title)} {hasActiveFilters && `(${replace('Active')})`}</span>
        <span className="transform transition-transform duration-200" aria-hidden="true">
          {isExpanded ? '▼' : '▶'}
        </span>
      </button>

      {isExpanded && (
        <div 
          id="filter-content"
          className={`space-y-4 p-4 ${semantic.sectionBg} rounded-md`}
        >
          {children}
        </div>
      )}
    </div>
  );
};

FilterContainer.propTypes = {
  title: PropTypes.string.isRequired,
  hasActiveFilters: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired
};

export default FilterContainer;

